import { Injectable } from '@angular/core';
import { Actions, Store } from '@ngxs/store';

import { ModalService } from 'src/app/services';
import {
  IOrderSetupModal,
  OrderSetupModal,
  OrderSetupModalData
} from './order-setup.component';
import { BaseProvider } from 'src/app/providers';
import { TICKETS_STATE_TOKEN } from 'src/app/store/tickets/tickets.state';
import { SetupTakeoutOrder } from 'src/app/store/tickets/tickets.action';
import { TICKET_ITEMS_STATE_TOKEN } from 'src/app/store/ticket-items/ticket-items.state';

@Injectable()
export class OrderSetupModalService {
  constructor(
    private readonly baseProvider: BaseProvider,
    private readonly modalService: ModalService,
    private readonly store: Store,
    private readonly actions$: Actions
  ) {}

  showOrderSetupModal(): void {
    const { tickets, selectedTicket } =
      this.store.selectSnapshot(TICKETS_STATE_TOKEN);
    const normalizedTicket = tickets.byId[selectedTicket.data];
    const ticket = normalizedTicket?.status ? normalizedTicket : undefined;

    if (ticket) {
      const { ticket_items } = ticket;
      const ticketItemsById = this.store.selectSnapshot(
        TICKET_ITEMS_STATE_TOKEN
      ).ticketItems.byId;
      const hasSomeTicketItems = (ticket_items || []).some(
        (ti) => !ticketItemsById[ti].is_fee_item
      );

      if (hasSomeTicketItems) {
        this.baseProvider.popupAlert(
          'Warning',
          'Unable to set the order for takeout.<br> Please void or cancel any ticket items.'
        );

        return;
      }
    }

    this.modalService.showModal<OrderSetupModalData, IOrderSetupModal>(
      OrderSetupModal,
      {
        ticket
      },
      {
        cssClass: 'pos-takeout-setup'
      },
      ({ data }) => {
        if (data) {
          const {
            ticket_date: date,
            meal_id: mealId,
            delivery_type: orderType,
            meal_delivery_area_timing_id: mealDeliveryAreaTiming
          } = data;

          this.store.dispatch(
            new SetupTakeoutOrder({
              date,
              mealId,
              orderType,
              mealDeliveryAreaTiming
            })
          );
        }
      }
    );
  }
}
